import classnames from "classnames";
import React from "react";

interface Props {
  onClick?: () => void;
  children: any;
  className?: string;
}

export default function PrimaryButton(props: Props) {
  return (
    <div
      className={classnames("primary-button", {
        [props.className]: !!props.className,
      })}
      onClick={props.onClick}
      role="button"
    >
      {props.children}
    </div>
  );
}
